module.exports = __webpack_public_path__ + "img/meijiaogy.39f789b7.jpg";